import { ref, h, Component, VNode } from 'vue'
import Modal from '@/components/Modal.vue'

interface ModalOptions {
    title?: string
    component?: Component
    props?: Record<string, undefined>
    disableClose?: boolean
}

const isOpen = ref(false)
const modalOptions = ref<ModalOptions | null>(null)

export function openModal(options: ModalOptions) {
    isOpen.value = true
    modalOptions.value = options
}

export function closeModal() {
    isOpen.value = false
    modalOptions.value = null
}

export function renderGlobalModal(): VNode | null {
    if (!isOpen.value || !modalOptions.value) return null
    const opts = modalOptions.value

    return h(Modal, {
        open: isOpen.value,
        title: opts.title,
        disableClose: opts.disableClose,
        modalClasses:
            'w-[95vw] h-[95vh] p-4 bg-white rounded-xl shadow-xl flex flex-col items-center justify-center overflow-y-scroll',
        onCloseModal: closeModal,
    }, {
        content: () =>
            opts.component ? h(opts.component, {
                ...opts.props, onClose: closeModal,
            }) : null,
    })
}